import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';

import cancelToken from 'component/core/cancel-token';
import { reset } from 'component/user/actions';
// import { logout } from 'component/api/user';

const useLogout = (): [() => void, boolean] => {
    const dispatch = useDispatch();
    const cancelTokenLogout = useMemo(cancelToken.create, []);

    const [pending, setPending] = useState<boolean>(false);

    useEffect(() => {
        return () => {
            cancelTokenLogout.remove();
        };
    }, []);

    const onClickLogout = (): void => {
        setPending(true);

        // logout({
        //     cancelToken: cancelTokenLogout.new()
        // })
        //     .then(() => {
        //         dispatch(reset());
        //     })
        //     .catch((payload) => {
        //         if(!axios.isCancel(payload)) {
        //             setPending(false);
        //             dispatch(reset());
        //         }
        //     });
    };

    return [onClickLogout, pending];
};

export default useLogout;
